import { render } from "./AlertDetail.vue?vue&type=template&id=c642bf10"
import script from "./AlertDetail.vue?vue&type=script&lang=js"
export * from "./AlertDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../SINTEZ/OKCU/webadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__